import Header from '../../layouts/admin/AdminHeader';
import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Box, Card, CardContent, FormControl, InputLabel, Select, Typography, MenuItem,  Switch, FormControlLabel } from '@mui/material';
import { getAllActiveProviderApi, getLeadCounts } from '../../api/adminApi/adminApi';
import useHeaders from '../../helpers/useHeaders';
import useEncryption from '../../services/useEncryption';
import { useEffect, useState } from 'react';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function AdminMain() {
  const headers = useHeaders();
  const { decryptData } = useEncryption();
  
  const [providers, setProviders] = useState([]);
  const [providerId, setProviderId] = useState("all");
  const [timeRange, setTimeRange] = useState("weekly");
  const [weeklyData, setWeeklyData] = useState(new Array(7).fill(null)); 
  const [monthlyData, setMonthlyData] = useState(new Array(12).fill(null)); 
  const [yearlyData, setYearlyData] = useState(new Array(4).fill(null));

  const getLastFourYears = () => {
    const currentYear = new Date().getFullYear();
    return [currentYear - 3, currentYear - 2, currentYear - 1, currentYear];
  };

  const prepareChartData = () => {
    if (timeRange === "weekly") {
        const mainLeadData = weeklyData.map(data => data?.mainLead ?? null);
        const locationLeadData = weeklyData.map(data => data?.locationLead ?? null);
        const typeFormLeadData = weeklyData.map(data => data?.typeFormLead ?? null);
        const allLeadData = weeklyData.map(data => data?.allLead ?? null);
        
        return {
            labels: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            datasets: [
                {
                    label: 'Main Lead',
                    data: mainLeadData,
                    fill: false,
                    backgroundColor: 'rgba(75, 192, 192, 1)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    spanGaps: true, 
                },
                {
                    label: 'Location Lead',
                    data: locationLeadData,
                    fill: false,
                    backgroundColor: 'rgba(255, 99, 132, 1)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    spanGaps: true, 
                },
                {
                  label: 'Typeform Lead',
                  data: typeFormLeadData,
                  fill: false,
                  backgroundColor: 'rgba(153, 102, 255, 1)',
                  borderColor: 'rgba(153, 102, 255, 1)',
                  spanGaps: true
              },
                {
                    label: 'All Lead',
                    data: allLeadData,
                    fill: false,
                    backgroundColor: 'rgba(54, 162, 235, 1)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    spanGaps: true, 
                },
            ],
        };
    } else if (timeRange === "monthly") {
        const mainLeadData = monthlyData.map(data => data?.mainLead ?? null);
        const locationLeadData = monthlyData.map(data => data?.locationLead ?? null);
        const typeFormLeadData = monthlyData.map(data => data?.typeFormLead ?? null);
        const allLeadData = monthlyData.map(data => data?.allLead ?? null);

        return {
            labels: [
                'January', 'February', 'March', 'April', 'May', 'June', 
                'July', 'August', 'September', 'October', 'November', 'December'
            ],
            datasets: [
                {
                    label: 'Main Lead',
                    data: mainLeadData,
                    fill: false,
                    backgroundColor: 'rgba(75, 192, 192, 1)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    spanGaps: true, 
                },
                {
                    label: 'Location Lead',
                    data: locationLeadData,
                    fill: false,
                    backgroundColor: 'rgba(255, 99, 132, 1)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    spanGaps: true,
                },
                {
                  label: 'Typeform Lead',
                  data: typeFormLeadData,
                  fill: false,
                  backgroundColor: 'rgba(153, 102, 255, 1)',
                  borderColor: 'rgba(153, 102, 255, 1)',
                  spanGaps: true
              },
                {
                    label: 'All Lead',
                    data: allLeadData,
                    fill: false,
                    backgroundColor: 'rgba(54, 162, 235, 1)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    spanGaps: true, 
                },
            ],
        };
    } else if (timeRange === "yearly") {
      const yearlyLabels = getLastFourYears();
      const mainLeadData = yearlyData.map(data => data?.mainLead ?? null);
      const locationLeadData = yearlyData.map(data => data?.locationLead ?? null);
      const typeFormLeadData = yearlyData.map(data => data?.typeFormLead ?? null);
      const allLeadData = yearlyData.map(data => data?.allLead ?? null);

      return {
          labels: yearlyLabels,
          datasets: [
              {
                  label: 'Main Lead',
                  data: mainLeadData,
                  fill: false,
                  backgroundColor: 'rgba(75, 192, 192, 1)',
                  borderColor: 'rgba(75, 192, 192, 1)',
                  spanGaps: true,
              },
              {
                  label: 'Location Lead',
                  data: locationLeadData,
                  fill: false,
                  backgroundColor: 'rgba(255, 99, 132, 1)',
                  borderColor: 'rgba(255, 99, 132, 1)',
                  spanGaps: true,
              },
              {
                label: 'Typeform Lead',
                data: typeFormLeadData,
                fill: false,
                backgroundColor: 'rgba(153, 102, 255, 1)',
                borderColor: 'rgba(153, 102, 255, 1)',
                spanGaps: true
              },
              {
                  label: 'All Lead',
                  data: allLeadData,
                  fill: false,
                  backgroundColor: 'rgba(54, 162, 235, 1)',
                  borderColor: 'rgba(54, 162, 235, 1)',
                  spanGaps: true,
              },
          ],
      };
  }
   
};

  
  const chartData = prepareChartData();
  
    const chartOptions = {
      responsive: true,
      plugins: {
        legend: { position: 'top' },
        title: { display: true, text: 'Leads Over Time' },
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 1,
            callback: function(value) {
              if (value % 1 === 0) return value;
            },
          },
        },
      },
    };

  

  const fetchData = async () => {
    try {
      const response = await getAllActiveProviderApi(headers);
      const decryptedData = decryptData(response?.data?.data);
      setProviders(decryptedData);
      // if (decryptedData.length); 
    } catch (error) {
      console.error('Error fetching providers:', error);
    }
  };

  const fetchLeadData = async () => {
    try {
      const response = await getLeadCounts(providerId, timeRange);
     
      const decryptedData = decryptData(response?.data?.data);

      if (timeRange === "weekly") {
        const { Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday } = decryptedData?.weeklyData || {};
        const weeklyDataArray = [Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday].map(item => item ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null });
        setWeeklyData(weeklyDataArray);
      }

      if (timeRange === "monthly") {
        const {
            January, February, March, April, May, June,
            July, August, September, October, November, December
        } = decryptedData?.monthlyData || {};
        
        const monthlyDataArray = [
            January ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            February ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            March ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            April ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            May ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            June ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            July ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            August ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            September ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            October ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            November ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
            December ?? { mainLead: null, locationLead: null,typeFormLead: null, allLead: null },
        ];
    
        setMonthlyData(monthlyDataArray);
    }

    if (timeRange === "yearly") {
      const lastFourYears = getLastFourYears();
    
      const yearlyDataArray = lastFourYears.map(year => 
        decryptedData?.yearlyData[year] ?? { mainLead: 0, locationLead: 0,typeFormLead: 0, allLead: 0 }
      );
    
      setYearlyData(yearlyDataArray);
    }
    } catch (error) {
      console.error('Error fetching lead data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (providerId && timeRange) {
      fetchLeadData();
    }
  }, [providerId, timeRange]);

  return (
    <Box>
      <Header pageTitle="Dashboard" />
      <Card sx={{ width: '100%', padding: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Leads Over Time
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <FormControl sx={{ minWidth: 160, mr: 2 }} size="small">
              <InputLabel id="time-range-label">Time Range</InputLabel>
              <Select
                labelId="time-range-label"
                id="time-range"
                name="timeRange"
                label="Time Range"
                value={timeRange}
                onChange={(e) => setTimeRange(e.target.value)}
              >
                <MenuItem value="weekly">Weekly</MenuItem>
                <MenuItem value="monthly">Monthly</MenuItem>
                <MenuItem value="yearly">Yearly</MenuItem>
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 260 }} size="small">
              <InputLabel id="location-label">Select Location</InputLabel>
              <Select
                labelId="location-label"
                id="location"
                name="location"
                label="Select Location"
                value={providerId}
                onChange={(e) => setProviderId(e.target.value)}
              >
                <MenuItem value={"all"}>All</MenuItem>
                {providers.map((provider) => (
                  <MenuItem key={provider.id} value={provider.id}>
                    {provider.organizationName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

         

          <Box sx={{ height: '400px', textAlign: 'center' }}>
            <Line data={chartData} options={chartOptions} />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default AdminMain;
